<template>
  <div class="form-input  text-blue">
    <router-link :to="{ path: '/' }" class="inline-block cursor-pointer">
      <Zondicon class="nav-icon w-8 fill-current" icon="Home" />
    </router-link>
    <router-link
        :to="{ path: '/notes' }"
        class="inline-block cursor-pointer"
    >
      <Zondicon class="nav-icon w-8 fill-current" icon="Globe" />
    </router-link>
    <div
      class="inline-block cursor-pointer"
      title="Recent notes"
      v-on:click="getRecentsOrCloseMenu"
    >
      <Zondicon class="nav-icon w-8 fill-current" icon="Time" />
    </div>
    <div
      class="inline-block cursor-pointer"
      title="Favorite notes"
      v-on:click="getFavoritesOrCloseMenu"
    >
      <Zondicon class="nav-icon w-8 fill-current" icon="StarFull" />
    </div>
<!--    <div-->
<!--      class="inline-block cursor-pointer"-->
<!--      id="search-dropdown-button"-->
<!--      title="Search your notes"-->
<!--      v-on:click="displaySearch"-->
<!--    >-->
<!--      <Zondicon class="nav-icon w-8 fill-current" icon="Search" />-->
<!--    </div>-->
  </div>
</template>

<script>
import { API_URL } from "../../env.js";
import Close from "../ui/Close.vue";
import SearchDropdown from "./SearchDropdown.vue";

export default {
  data() {
    return {
      recents: []
    };
  },
  components: {
    Close,
    SearchDropdown
  },
  // props: ['handleSearchSubmit'],
  computed: {
    noResults() {
      return !this.hasRetrievedRecent;
    },
    hasRetrievedRecent() {
      return this.recents.length > 0;
    },
    book: function() {
      return this.$store.state.notes.book;
    },
    user() {
      return this.$store.state.notes.user;
    },
    showSearch() {
      return this.$store.state.notes.showSearch;
    },
    showOptions() {
      return this.$store.state.notes.showOptions;
    }
  },

  methods: {
    getRecentsOrCloseMenu() {
      if (this.$store.state.notes.showRecent) {
        // already open
        this.$store.dispatch("aShowRecent", { show: false });
        return;
      }
      let book = null;
      if (this.$route.query.book || this.$route.params.note) {
        book = this.book.id;
      }
      this.$store.dispatch("aGetRecentNotes", book);
    },
    getFavoritesOrCloseMenu() {
      if (this.$store.state.notes.showFavorite) {
        // already open
        this.$store.dispatch("aShowFavorite", { show: false });
        return;
      }
      let book = null;
      if (this.$route.query.book || this.$route.params.note) {
        book = this.book.id;
      }
      this.$store.dispatch("aGetFavoriteNotes", book);
    },
    displaySearch(e) {
      e.stopPropagation(); // stop outside click from closing dropdown
      this.$store.dispatch("aShowSearch", { show: !this.showSearch });
      // var inputBox = document.getElementById('search-box-input');
      // inputBox.click();
      // inputBox.focus();
      // inputBox.setActive;
      // inputBox.select();
    },
  }
};
</script>

<style lang="scss">
.clock-icon {
  width: 25px;
  height: 25px;
}

.plus-icon {
  width: 25px;
  height: 25px;
}

.clear-search {
  position: absolute;
  padding: 9px;
  z-index: 1;
  right: 5px;
  top: 0px;
}

.clear-search svg {
  fill: #aaa;

  cursor: pointer;
}

.clear-search svg:hover {
  fill: #700;
}

.page .clear-search {
  right: 0px;
  padding: 15px;
}

@media (min-width: 768px) {
  // On Desktop, move the icons (X button on search and
  // marker for location) back in position.
  .clear-search {
    right: 8px;
  }
}

.terms-search .close {
  right: 0px;
  position: absolute;
  padding: 10px;
  cursor: pointer;
}

.clear-search {
  position: absolute;
  padding: 9px;
  z-index: 1;
  right: 5px;
  top: 0px;
}

.clear-search svg {
  fill: #aaa;

  cursor: pointer;
}

.clear-search svg:hover {
  fill: #700;
}

.page .clear-search {
  right: 0px;
  padding: 15px;
}

@media (min-width: 768px) {
  // On Desktop, move the icons (X button on search and
  // marker for location) back in position.
  .clear-search {
    right: 8px;
  }
}

.terms-search .close {
  right: 0px;
  position: absolute;
  padding: 10px;
  cursor: pointer;
}
</style>
